import { z } from 'zod';

/** A single editable leaf (project / time-off / added-project / overhead). All fields optional. */
const leafSchema = z
  .object({
    billBy: z.string(),
    projectId: z.number().nullable(),
    description: z.string(),
    hours: z.number(),
    effectiveRate: z.number(),
  })
  .partial();

/**
 * The form is keyed by STABLE ENTITY IDS, not array index (see `getBillFieldName`):
 * `member.m{memberId}.project.p{projectId}.hours`, etc. So the shape is nested records
 * rather than arrays. The resolver is only used for typing — submission is gated by
 * `useBillsGenerateDisabled`, not this schema — so a permissive record shape is enough.
 */
export const generateBillsValidationSchema = z.object({
  member: z.record(
    z.string(),
    z.object({
      project: z.record(z.string(), leafSchema).optional(),
      timeOff: z.record(z.string(), leafSchema).optional(),
      addedProject: z.record(z.string(), leafSchema).optional(),
      overhead: z.record(z.string(), leafSchema).optional(),
    })
  ),
});

export type GenerateBillsTableFormValues = z.infer<typeof generateBillsValidationSchema>;
